import { effects } from 'redux-saga'

import callWithHmac from '../effects/callWithHmac'
import { begin, end } from '../../modules/loading'
import { receiveOffers } from '../../modules/product'

export default function* loadOffers({ invocation }) {
  try {
    yield effects.put.resolve(begin('offers'))

    const results = yield effects.call(callWithHmac, invocation.getOffers)

    yield effects.put.resolve(receiveOffers(results.offers))
  } finally {
    yield effects.put.resolve(end('offers'))
  }
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/redux/sagas/product/loadOffers.js